import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=2123f545&"
import script from "./BaseInputFile.vue?vue&type=script&lang=ts&"
export * from "./BaseInputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports